import './wdyr.js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@/App';

// Suppress benign ResizeObserver loop errors that browsers fire when an observer
// callback causes layout changes that cannot be delivered in the same frame.
// This is a known browser behavior and not an application bug.
// See: https://github.com/WICG/resize-observer/issues/38
window.addEventListener('error', (event) => {
  if (event?.message?.includes?.('ResizeObserver loop')) {
    event.stopImmediatePropagation();
  }
});

ReactDOM.createRoot(document.getElementById('root')).render(<App />);
